// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface AddressValidationModel {
    id?: string;
    addressLine1: string;
    line1?: string;
    addressLine2: string;
    line2?: string;
    addressLine3: string;
    line3?: string;
    city: string;
    country: string;
    postalCode: string;
    state: string;
    region?: string;
    date?: number;
}
export interface ValidateAddressWithAvalaraApiParameter extends ApiParameter {
    address: AddressValidationModel;
}

const billTosUrl = "/api/custom/addressValidation";

export async function validateAddressWithAvalara(parameter: ValidateAddressWithAvalaraApiParameter) {
    const additionalQueryStringParametersTemp = parameter.address;
    additionalQueryStringParametersTemp.date = new Date().getTime();
    try {
        const billToModel = await get<any>(`${billTosUrl}`, {
            additionalQueryStringParameters: additionalQueryStringParametersTemp,
        });
        return billToModel;
    } catch (error) {
        return error;
    }
}
